export default "__VITE_ASSET__d687b217__$_?nuxt_component=async&nuxt_component_name=SvgoSage__"